<div style="font-size: 14px; font-style: italic;" *ngIf="successPage">
    <div class="confirmation-container">
        <div class="tick-mark">
          <img src="../../../../assets/images/tickmark.webp" alt="Success" />
        </div>
        <h1>Registration Successful!</h1>
        <p class="instructions">
            Your request is valid for 7 days from the date of registration. 
            Submit your User activation document in time dually signed to Nodal Officer / 
            Complaint Cell for user login authorization.
        </p>
        <p class="instructions">
            Thank you!
        </p>
        <div class="button-container">
            <button mat-flat-button (click)="downloadForm()">Download Registration Form</button>
            <button mat-flat-button (click)="backToLogin()">Back</button>
        </div>
    </div>     
</div>
<mat-horizontal-stepper *ngIf="!successPage" linear #stepper="matHorizontalStepper" style="background-color: white;">
    <!-- Personal Details Step -->
    <mat-step [stepControl]="personalDetailsForm">
        <form [formGroup]="personalDetailsForm">
            <ng-template matStepLabel>Personal Details</ng-template>

            <!-- Rank Field -->
            <mat-form-field appearance="outline" style="margin-top: 10px;" aria-disabled="true" *ngIf="false">
                <mat-label>Rank</mat-label>
                <input readonly matInput formControlName="rank" placeholder="Enter rank" maxlength="20">
                <mat-error *ngIf="personalDetailsForm.get('rank')?.hasError('pattern')">
                Rank can only contain alphabets and spaces
                </mat-error>
            </mat-form-field>
            
            <!-- First Name Field -->
            <mat-form-field appearance="outline" style="margin-top: 10px;" *ngIf="false">
                <mat-label>First Name *</mat-label>
                <input matInput formControlName="firstName" required placeholder="Enter first name" maxlength="30">
                <mat-error *ngIf="personalDetailsForm.get('firstName')?.hasError('required')">
                First Name is required
                </mat-error>
                <mat-error *ngIf="personalDetailsForm.get('firstName')?.hasError('pattern')">
                First Name can only contain alphabets and spaces
                </mat-error>
            </mat-form-field>
            
            <!-- Last Name Field -->
            <mat-form-field appearance="outline" style="margin-top: 10px;" *ngIf="false">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastName" placeholder="Enter last name" maxlength="30">
                <mat-error *ngIf="personalDetailsForm.get('lastName')?.hasError('pattern')">
                Last Name can only contain alphabets and spaces
                </mat-error>
            </mat-form-field>
            

            <mat-form-field appearance="outline" style="margin-top: 10px;">
                <mat-label>Mobile No *</mat-label>
                <input matInput formControlName="mobileNumber" required maxlength="10">
                <mat-error *ngIf="personalDetailsForm.get('mobileNumber')?.hasError('required')">
                    Mobile number is required
                </mat-error>
                <mat-error *ngIf="personalDetailsForm.get('mobileNumber')?.hasError('pattern')">
                    Enter a valid 10-digit mobile number
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Email Address *</mat-label>
                <input matInput formControlName="emailAddress" required>
                <mat-error *ngIf="personalDetailsForm.get('emailAddress')?.hasError('required')">
                    Email Address is required
                </mat-error>
                <mat-error *ngIf="personalDetailsForm.get('emailAddress')?.hasError('email')">
                    Invalid Email Address
                </mat-error>
                <mat-error *ngIf="personalDetailsForm.get('emailAddress')?.hasError('pattern')">
                    Invalid Email Address
                </mat-error>
            </mat-form-field>

            <mat-checkbox formControlName="allowSms" required>Allow SMS</mat-checkbox>
            <mat-error *ngIf="personalDetailsForm.get('allowSms')?.hasError('required')">
                Consent for SMS is required
            </mat-error>

            <mat-checkbox formControlName="allowEmail" required>Allow Email</mat-checkbox>
            <mat-error *ngIf="personalDetailsForm.get('allowEmail')?.hasError('required')">
                Consent for Email is required
            </mat-error>

            <p style="font-style: italic; font-size: 14px;"># As per TRAI regulations, user consent is mandatory for transmitting SMS and Email messages to individuals</p>

            <div>
                <button mat-stroked-button style="margin-right: 10px;" (click)="backToLogin()">Back</button>
                <button mat-flat-button matStepperNext [disabled]="!personalDetailsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <!-- Location Details Step -->
    <mat-step [stepControl]="locationDetailsForm">
        <form [formGroup]="locationDetailsForm">
            <ng-template matStepLabel>Location Details</ng-template>

            <mat-form-field appearance="outline" style="margin-top: 5px;">
                <mat-label>Station Name *</mat-label>
                <mat-select formControlName="zoneId" required (selectionChange)="onZoneSelect($event.value)">
                    <mat-option *ngFor="let zone of zones" [value]="zone.code">{{ zone.value }}</mat-option>
                </mat-select>
                <mat-error *ngIf="locationDetailsForm.get('zoneId')?.hasError('required')">
                    Station Name is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-top: 5px;">
                <mat-label>Area Name *</mat-label>
                <mat-select formControlName="areaName" required>
                    <mat-option *ngFor="let area of areas" [value]="area.value">{{ area.value }}</mat-option>
                </mat-select>
                <mat-error *ngIf="locationDetailsForm.get('areaName')?.hasError('required')">
                    Area Name is required
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Quarter No</mat-label>
                <input matInput formControlName="quarterNo">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Block Number *</mat-label>
                <input matInput formControlName="blockNumber" required>
                <mat-error *ngIf="locationDetailsForm.get('blockNumber')?.hasError('required')">
                    Block Number is required
                </mat-error>
            </mat-form-field>            

            <div>
                <button mat-stroked-button style="margin-right: 10px;" matStepperPrevious>Back</button>
                <button mat-flat-button matStepperNext [disabled]="!locationDetailsForm.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <!-- Login Details Step -->
    <mat-step [stepControl]="loginDetailsForm">
        <form [formGroup]="loginDetailsForm">
            <ng-template matStepLabel>Login Details</ng-template>

            <!-- Username Field -->
            <mat-form-field appearance="outline" style="margin-top: 10px;">
                <mat-label>Username</mat-label>
                <input matInput formControlName="userName" (ngModelChange)="isUsernameValid = null" autocomplete="new-username" autocorrect="off" readonly
                onfocus="this.removeAttribute('readonly')"
               spellcheck="false" (copy)="false" (cut)="false" (paste)="false"/>
                <mat-error *ngIf="loginDetailsForm.get('userName')?.hasError('required')">
                Username is required.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('userName')?.hasError('minlength')">
                Username must be at least 5 characters long.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('userName')?.hasError('maxlength')">
                Username cannot be more than 12 characters long.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('userName')?.hasError('pattern')">
                Username can only contain letters and numbers.
                </mat-error>
                <mat-error style="color: red;" *ngIf="loginDetailsForm.get('userName')?.hasError('usernameTaken')">
                    Consider taking another username.
                </mat-error>
                <mat-hint style="color: red;" *ngIf="isUsernameValid === false">Consider taking another username.</mat-hint>
                <mat-hint style="color: green;" *ngIf="isUsernameValid === true">Username Acceptable ✔</mat-hint>
            </mat-form-field>

            <!-- Password Field -->
            <mat-form-field appearance="outline" style="margin-top: 15px;">
                <mat-label>Password</mat-label>
                <input matInput type="password" formControlName="password" autocomplete="new-password" autocorrect="off" onfocus="this.value=''"
                spellcheck="false" (copy)="false" (cut)="false" (paste)="false"/>
                <mat-error *ngIf="loginDetailsForm.get('password')?.hasError('required')">
                Password is required.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('password')?.hasError('minlength')">
                Password must be at least 8 characters long.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('password')?.hasError('maxlength')">
                Password cannot be more than 12 characters long.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('password')?.hasError('pattern')">
                Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.
                </mat-error>
            </mat-form-field>

            <!-- Confirm Password Field -->
            <mat-form-field appearance="outline" style="margin-top: 25px;">
                <mat-label>Confirm Password</mat-label>
                <input matInput type="password" formControlName="confirmPassword" />
                <mat-error *ngIf="loginDetailsForm.get('confirmPassword')?.hasError('required')">
                Confirm password is required.
                </mat-error>
                <mat-error *ngIf="loginDetailsForm.get('confirmPassword')?.hasError('mustMatch')">
                Passwords must match.
                </mat-error>
            </mat-form-field>
            <div>
                <button mat-stroked-button style="margin-right: 10px;" matStepperPrevious>Back</button>
                <button mat-flat-button (click)="onSubmit()" [disabled]="!loginDetailsForm.valid">Submit</button>
            </div>
        </form>
    </mat-step>
</mat-horizontal-stepper>